const MESSAGE_DISPLAY_LIMIT = 2
const MESSAGE_QUEUE_LIMIT = 60
const MIN_MESSAGE_TIMEOUT = 1000
const MAX_MESSAGE_TIMEOUT = 7000
class FlashMessage {
    constructor(flash, key, properties) {
        this.flash = flash
        this.key = key
        this.message = properties.message
        this.status = properties.status
        this.icon = properties.icon
        this.link = properties.link
        this.innerCallback = properties.callback

        this.timeout = null

        // force `this` to be bound properly on these methods
        // I'm sure there is a better way but I don't know it
        this.enter = () => {
            this.clearTimeout()
            this.flash.pause()
        }

        this.leave = () => {
            this.flash.resume()
        }

        this.dismiss = () => {
            this.leave()
            this.flash.dismiss(this)
        }

        this.callback = () => {
            this.leave()
            this.innerCallback(...arguments)
        }
    }

    clearTimeout() {
        if (this.timeout) {
            this.timeout = clearTimeout(this.timeout)
        }
    }
    setTimeout(timeout) {
        this.timeout = setTimeout(this.dismiss, timeout)
    }
}

export default class {
    constructor() {
        this.messages = []
        this.currentMessages = []
        this.key = 0
        this.paused = false
    }
    get current() {
        return this.currentMessages
    }
    push(properties) {
        var message = new FlashMessage(this, this.key++, properties)
        if (this.messages.length < MESSAGE_QUEUE_LIMIT) {
            this.messages.push(message)
            this.recomputeCurrentMessages()
        }
    }
    pause() {
        this.paused = true
    }

    resume() {
        this.paused = false
        this.recomputeCurrentMessages()
    }
    dismiss(message) {
        var index = this.messages.indexOf(message)
        if (index > -1) {
            this.messages.splice(index, 1)
        }
        this.recomputeCurrentMessages()
    }
    recomputeCurrentMessages() {
        if (this.paused) {
            return
        }

        var currentMessages = this.messages.slice(0, MESSAGE_DISPLAY_LIMIT)

        currentMessages.forEach(message => {
            // call setTimeout when the message becomes eligible for display, not when it is
            // first enqueued; this will ensure that we don't dismiss a message before
            // the user ever sees it
            if (!message.timeout) {
                message.setTimeout(this.computeCurrentTimeout())
            }
        })

        this.currentMessages = currentMessages
    }

    // the timeout is dynammic - if we end up with a bunch of messages queued up, we display
    // them with a progressively shorter timeout
    computeCurrentTimeout() {
        return Math.min(
            MAX_MESSAGE_TIMEOUT,
            Math.max(MAX_MESSAGE_TIMEOUT - (this.messages.length - MESSAGE_DISPLAY_LIMIT) * 100, MIN_MESSAGE_TIMEOUT)
        )
    }
}
